<template>
<v-app
      id="dashboard-view"
      light>
  <v-main>
    
      <core-toolbar />
      <core-drawer />
      <v-fade-transition mode="out-in">
        <router-view />
      </v-fade-transition>
      <!-- <core-footer v-if="$route.name !== 'Maps'" /> -->
    
  </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'InternalPage',
  metaInfo () {
    return {
      title: this.$store.getters.applicationtitle
    }
  }
}
</script>
